export const keyMessages = [
  '6-in-1 Visual Teaching System',
  '150 Ready-to-Teach Pastry Lessons',
  '100% Visual',
  '5 Professional Bonus Guides',
  'Beginner to Advanced',
  'Ready to Open and Teach',
  'Save Hours of Planning',
]
